export const SAVE_PLAN_FORM_FIELDS = 'SAVE_PLAN_FORM_FIELDS';
export const savePlanFormFields = quote => dispatch =>
  dispatch({
    type: SAVE_PLAN_FORM_FIELDS,
    payload: quote,
  });

export const SET_USE_SAVED_PLAN_FORM_FIELDS = 'SET_USE_SAVED_PLAN_FORM_FIELDS';
export const setUseSavedPlanFormFields = (use = false) => ({
  type: SET_USE_SAVED_PLAN_FORM_FIELDS,
  payload: use,
});
